import { useMutation } from "@tanstack/react-query";
import { apiV1 } from "api-v2";
import type { UserListItem } from "newui/features/Auth/types/userInvite";

interface RegisterPayload {
  password: string;
  password_confirmation: string;
  phone: string;
  registration_token: string;
}

interface RegisterResponse {
  access_token: string;
  user: UserListItem;
}

interface RegisterError {
  code?: string;
  errors?: Record<string, string[]>;
  message: string;
}

export const useRegisterMutation = () =>
  useMutation<RegisterResponse, RegisterError, RegisterPayload>({
    mutationFn: async (payload) => {
      const res = await apiV1.post<RegisterResponse>(
        "auth/invite/register",
        payload
      );
      return res.data;
    },
    retry: false,
  });
